<div *ngIf="isVisible" class="rp-overlay">
  <div class="rp-card">

    <!-- Top accent bar -->
    <div class="rp-accent-bar"></div>

    <!-- Close -->
    <button type="button" class="rp-close" (click)="handleCancel()" aria-label="Fermer">
      <i class="fas fa-times"></i>
    </button>

    <!-- Header -->
    <div class="rp-header">
      <div class="rp-icon-wrap">
        <i [class]="step === 1 ? 'fas fa-envelope' : step === 2 ? 'fas fa-shield-halved' : 'fas fa-lock-open'"></i>
      </div>
      <h2 class="rp-title">
        <ng-container [ngSwitch]="step">
          <span *ngSwitchCase="1">Réinitialisation du mot de passe</span>
          <span *ngSwitchCase="2">Vérification du code</span>
          <span *ngSwitchCase="3">Nouveau mot de passe</span>
        </ng-container>
      </h2>
      <p class="rp-subtitle">
        <ng-container [ngSwitch]="step">
          <span *ngSwitchCase="1">Saisissez votre adresse email pour recevoir un code</span>
          <span *ngSwitchCase="2">Entrez le code à 6 chiffres envoyé à <strong>{{ userEmail }}</strong></span>
          <span *ngSwitchCase="3">Choisissez un nouveau mot de passe sécurisé</span>
        </ng-container>
      </p>
    </div>

    <!-- Step indicators -->
    <div class="rp-steps">
      <div class="rp-step-dot" [class.active]="step >= 1" [class.done]="step > 1"></div>
      <div class="rp-step-line" [class.active]="step > 1"></div>
      <div class="rp-step-dot" [class.active]="step >= 2" [class.done]="step > 2"></div>
      <div class="rp-step-line" [class.active]="step > 2"></div>
      <div class="rp-step-dot" [class.active]="step >= 3"></div>
    </div>

    <!-- STEP 1: Email -->
    <form *ngIf="step === 1" class="rp-form" (ngSubmit)="submitEmail()" [formGroup]="emailForm">
      <div class="rp-field">
        <label class="rp-label" for="userEmail">Adresse email</label>
        <div class="rp-input-wrap">
          <i class="fas fa-envelope rp-input-icon"></i>
          <input class="rp-input" formControlName="userEmail" id="userEmail"
                 type="email" placeholder="votre@email.com" autocomplete="email" />
        </div>
        <div *ngIf="emailForm.controls['userEmail'].invalid && emailForm.controls['userEmail'].dirty" class="rp-error">
          <i class="fas fa-exclamation-circle"></i> Email requis et valide
        </div>
      </div>
      <button class="rp-btn-submit" type="submit" [disabled]="loading">
        <span *ngIf="!loading"><i class="fas fa-paper-plane me-2"></i>Envoyer le code</span>
        <span *ngIf="loading" class="d-flex align-items-center gap-2 justify-content-center">
          <i class="fas fa-spinner fa-spin"></i> Envoi en cours…
        </span>
      </button>
    </form>

    <!-- STEP 2: 6-digit code -->
    <div *ngIf="step === 2" class="rp-form">
      <div class="rp-code-row">
        <input *ngFor="let d of codeDigits; let i = index"
               [class]="'rp-code-input code-input-' + i"
               type="text"
               inputmode="numeric"
               maxlength="1"
               [value]="codeDigits[i]"
               (input)="onCodeInput($event, i)"
               (keydown)="onCodeKeydown($event, i)"
               (paste)="onCodePaste($event)"
               autocomplete="one-time-code" />
      </div>
      <div *ngIf="codeError" class="rp-error rp-code-error">
        <i class="fas fa-exclamation-circle"></i> {{ codeError }}
      </div>
      <button class="rp-btn-submit" (click)="verifyCode()" [disabled]="loading || codeString.length !== 6">
        <span *ngIf="!loading"><i class="fas fa-check me-2"></i>Vérifier le code</span>
        <span *ngIf="loading" class="d-flex align-items-center gap-2 justify-content-center">
          <i class="fas fa-spinner fa-spin"></i> Vérification…
        </span>
      </button>
      <div class="rp-resend">
        <span *ngIf="resendCooldown > 0" class="rp-resend-timer">Renvoyer dans {{ resendCooldown }}s</span>
        <button *ngIf="resendCooldown <= 0" class="rp-resend-btn" (click)="resendCode()" [disabled]="loading">
          Renvoyer le code
        </button>
      </div>
    </div>

    <!-- STEP 3: New password -->
    <form *ngIf="step === 3" class="rp-form" (ngSubmit)="submitNewPassword()" [formGroup]="passwordForm">
      <div class="rp-field">
        <label class="rp-label" for="newPassword">Nouveau mot de passe</label>
        <div class="rp-input-wrap">
          <i class="fas fa-lock rp-input-icon"></i>
          <input class="rp-input" formControlName="newPassword" id="newPassword"
                 [type]="passwordVisible ? 'text' : 'password'" placeholder="••••••••" autocomplete="new-password" />
          <button type="button" class="rp-eye-btn" (click)="passwordVisible = !passwordVisible" aria-label="Afficher/masquer">
            <i [class]="passwordVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <div *ngIf="passwordForm.controls['newPassword'].invalid && passwordForm.controls['newPassword'].dirty" class="rp-error">
          <i class="fas fa-exclamation-circle"></i> Minimum 6 caractères
        </div>
      </div>
      <div class="rp-field">
        <label class="rp-label" for="confirmPassword">Confirmer le mot de passe</label>
        <div class="rp-input-wrap">
          <i class="fas fa-lock rp-input-icon"></i>
          <input class="rp-input" formControlName="confirmPassword" id="confirmPassword"
                 type="password" placeholder="••••••••" autocomplete="new-password" />
        </div>
        <div *ngIf="passwordForm.controls['confirmPassword'].invalid && passwordForm.controls['confirmPassword'].dirty" class="rp-error">
          <i class="fas fa-exclamation-circle"></i> Confirmation requise
        </div>
      </div>
      <button class="rp-btn-submit" type="submit" [disabled]="loading">
        <span *ngIf="!loading"><i class="fas fa-check-circle me-2"></i>Réinitialiser</span>
        <span *ngIf="loading" class="d-flex align-items-center gap-2 justify-content-center">
          <i class="fas fa-spinner fa-spin"></i> En cours…
        </span>
      </button>
    </form>

  </div>
</div>
